<template>
  <Modal
    v-if="modelValue"
    :title="t('Device Connection')"
    :is-center="false"
    :is-static="false"
    @close="close"
  >
    <div class="form" role="radiogroup" aria-label="Select device type">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="device1" value="BLE" v-model="selected"
          name="device"
          @keyup.enter.prevent="selected = $event.target.value">
        <label class="form-check-label" for="device1">Bluetooth LE</label>
      </div>
      <div class="form-check">
        <input type="radio" class="form-check-input" id="device2" value="COM" v-model="selected"
          name="device"
          @keyup.enter.prevent="selected = $event.target.value">
        <label class="form-check-label" for="device2">USB</label>
      </div>
    </div>
    <div class="form-check-inline">
      <button
          v-if="selected == 'BLE' || selected == 'COM' || selected == 'BT SPP'"
          class="btn add-dotpad"
          @click="addDotPad"
          aria-label="add new device connection">
        Search Device
      </button>
    </div>
    <table aria-label="connected devices list">
      <thead>
      <tr>
        <th scope="col">No.</th>
        <th scope="col">Device Name</th>
        <th scope="col">Disconnect button</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in dotpadJsonList" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ item.deviceName }}</td>
          <td>
            <button
              :aria-label="'disconnect device, ' + item.deviceName"
              @click.stop.prevent="disConnect(index)"
            >Disconnect</button>
          </td>
        </tr>
      </tbody>
    </table>
  </Modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Dotpad } from "@/js/dot/Dotpad.js";
import { DotpadList } from "@/js/dot/DotpadList.js";
import { useI18n } from 'vue-i18n';
import Modal from "@/components/common/MyModal.vue";

const { t } = useI18n();
const props = defineProps({
  modelValue: Boolean,
});
console.log(props.modelValue)
const emits = defineEmits(["initializeDotPad", "update:modelValue"]);

const selected = ref("BLE");
const dotpadJsonList = ref([]);
const dotpadList = ref([]);
// const handleKeyInput = (dotpadInstance, keyEvent, edgethreshold) => {
//     console.log("Key Pressed:", keyEvent.name);
//     console.log("Threshold:", edgethreshold);
// };
function addDotPad() {
  const dotpad = new Dotpad(this);
  dotpad.disconnCallbackFtn = disconnectCallback;
  dotpad.BLE_checked = selected.value === "BLE";
  dotpad.con_select = selected.value;
    
  // if (dotpad) {
  //   dotpad.KeyInputCallbackFtn = handleKeyInput;
  //       console.log("KeyInputCallbackFtn이 정상적으로 설정되었습니다!");
  // } else {
  //       console.log("dotpadInstance 생성 실패!");
  // }

  dotpad.request()
    .then(() => dotpad.connect())
    .then(() => {
      const deviceName = dotpad.connectedDeviceName;
      if (deviceName !== "No device Connected") {
        DotpadList.addDotPad(dotpad);
        emits("initializeDotPad", dotpad);
        reloadDeviceList();
      }

      setTimeout(() => {
        if (!dotpad.deviceInfo.deviceName) {
          const message = t("정보를 가져올 수 없습니다.");
          // swal({
          //   title: message,
          //   showConfirmButton: false,
          //   timer: 3000
          // });

          // swal alert 패키지 제거되어 임시로 alert 으로 대체
          alert(message);
        }
      }, 2000);
    })
    .catch(error => console.error(error));
}

function reloadDeviceList() {
  dotpadJsonList.value = DotpadList.getJsonList();
}

function disConnect(index) {
  const deviceName = dotpadJsonList.value[index].deviceName;
  const dotPad = DotpadList.getDotPad(deviceName);
  if (dotPad) {
    dotPad.disconnect();
  }
}

function disconnectCallback(deviceName) {
  DotpadList.removeDotPad(deviceName);
  reloadDeviceList();
}

const close = () => {
  emits("update:modelValue", false);
};

onMounted(() => {
  reloadDeviceList();
  dotpadList.value = DotpadList.getList();
});
</script>

<style scoped>
.form-check-input {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

/* 선택되면 완전 꽉 찬 원 */
.form-check-input:checked {
  background-color: #ea5414;
  border-color: #ea5414;
}

/* 포커스 링 제거 */
.form-check-input:focus {
  outline: none;
  box-shadow: none;
}


.form {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-check {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
}


.form-check-inline {
  display: flex;
  justify-content: flex-end;
  margin-top: -70px;   /* 버튼을 오른쪽 위에 정렬 */
}

.add-dotpad {
  background: #ea5414;
  font-size: 20px;
  color: #fff;
  width: 220px;
  border-radius: 40px;
  padding: 10px 20px;
  font-weight: 600;

  border: none;          /* ✅ 테두리 제거 */
  outline: none;         /* ✅ 포커스 라인 제거 */
  box-shadow: none;      /* ✅ 그림자 제거 */
}



.dot-middleware {
  background: #a5a5a7;
  font-size: 18px;
  color: #fff;
  border-radius: 20px;
  padding: 5px 10px;
}

.form-check-inline .add-dotpad:hover {
  opacity: 0.8;
}

.add-dotpad:focus-visible {
  opacity: 0.8;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 40px;
  background: transparent;
}

table thead th {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
  text-align: left;
  padding: 16px 8px;
  border-bottom: 2px solid #e5e7eb;   /* ✅ 살짝 두껍게 */
}


table tbody tr {
  border-bottom: none;   /* ❌ 이거 제거 */
}


table tbody td {
  padding: 18px 8px;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;   /* ✅ 여기서 선 */
}



table tr td button {
  font-size: 18px;
  background: #c4c4c4;
  border: none;
  border-radius: 30px;
  color: white;
  padding: 10px 22px;
  font-weight: 600;
}


table tr td button:hover, table tr td button:active, table tr td button:focus {
  opacity: 0.8;
  background: #aaabab !important;
  border-color: #aaabab !important;
  color: #fff !important;
}
</style>
